import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ 
  searchTerm, 
  onSearchChange, 
  selectedFloorType, 
  onFloorTypeChange, 
  selectedRoom, 
  onRoomChange,
  selectedTag,
  onTagChange,
  floorTypes, 
  rooms,
  tags,
  onClearFilters 
}) => {
  const hasActiveFilters = searchTerm || selectedFloorType || selectedRoom || selectedTag;

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-text-primary flex items-center gap-2">
          <Icon name="Filter" size={16} />
          Filters
        </h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={14}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search projects..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
        />

        <Select
          placeholder="All Floor Types"
          options={[
            { value: '', label: 'All Floor Types' },
            ...floorTypes?.map(ft => ({ value: ft, label: ft }))
          ]}
          value={selectedFloorType}
          onChange={onFloorTypeChange}
        />

        <Select
          placeholder="All Rooms"
          options={[
            { value: '', label: 'All Rooms' },
            ...rooms?.map(r => ({ value: r, label: r }))
          ]}
          value={selectedRoom}
          onChange={onRoomChange}
        />

        <Select
          placeholder="All Tags"
          options={[
            { value: '', label: 'All Tags' },
            ...tags?.map(t => ({ value: t, label: t }))
          ]}
          value={selectedTag}
          onChange={onTagChange}
          searchable
        />
      </div>
    </div>
  );
};

export default FilterBar;